//#region src/components/SourceTabs/SourceTabs.module.css
var e = "_container_12tg3_1", t = "_hint_12tg3_5", n = "_list_12tg3_14", r = "_option_12tg3_24", i = "_button_12tg3_37", a = "_selected_12tg3_55", o = "_content_12tg3_68", s = "_tail_12tg3_78", c = {
	container: e,
	hint: t,
	list: n,
	option: r,
	button: i,
	selected: a,
	content: o,
	tail: s
};
//#endregion
export { i as button, e as container, o as content, c as default, t as hint, n as list, r as option, a as selected, s as tail };
